import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  LayoutDashboard, Users, PawPrint, QrCode, MapPin,
  Phone, ClipboardList, Store, Package, LogOut, Menu, X
} from 'lucide-react';
import { UserHeader } from '../../components/layout/UserHeader';

const menuItems = [
  { to: '/admin/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/admin/usuarios', icon: Users, label: 'Usuarios' },
  { to: '/admin/mascotas', icon: PawPrint, label: 'Mascotas' },
  { to: '/admin/codigos', icon: QrCode, label: 'Códigos QR' },
  { to: '/admin/ubicaciones', icon: MapPin, label: 'Ubicaciones' },
  { to: '/admin/contactos', icon: Phone, label: 'Contactos' },
  { to: '/admin/historial', icon: ClipboardList, label: 'Historial' },
  { to: '/admin/socios', icon: Store, label: 'Socios' },
  { to: '/admin/productos', icon: Package, label: 'Productos' },
];

const AdminLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) {
        setSidebarOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <>
      <UserHeader />
      <br />
      <br />
      <br />
      <div style={{ display: 'flex', minHeight: '100vh', position: 'relative' }}>
        {/* Header móvil */}
        {isMobile && (
          <header
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              zIndex: 100,
              background: 'var(--sp-primary)',
              color: '#fff',
              padding: '0.8rem 1rem',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            }}
          >
            <h2 style={{ fontSize: '1.1rem', fontWeight: 800, margin: 0 }}>SmartPet Admin</h2>
            <button
              onClick={toggleSidebar}
              style={{
                background: 'none',
                border: 'none',
                color: '#fff',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {sidebarOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </header>
        )}

        {/* Overlay móvil */}
        {isMobile && sidebarOpen && (
          <div
            onClick={closeSidebar}
            style={{
              position: 'fixed',
              inset: 0,
              background: 'rgba(0,0,0,0.4)',
              zIndex: 50,
            }}
          />
        )}

        {/* Sidebar */}
        <aside
          style={{
            width: 260,
            background: 'var(--sp-primary)',
            color: '#fff',
            padding: '1.5rem 1rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            position: isMobile ? 'fixed' : 'sticky',
            top: 0,
            left: isMobile ? (sidebarOpen ? 0 : '-100%') : 0,
            height: '100vh',
            overflowY: 'auto',
            zIndex: isMobile ? 60 : 1,
            transition: 'left 0.3s ease',
          }}
        >
          {!isMobile && (
            <h2 style={{ fontSize: '1.3rem', fontWeight: 800, marginBottom: '1.5rem', paddingLeft: '0.75rem' }}>
              SmartPet Admin
            </h2>
          )}

          <nav style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', flex: 1 }}>
            {menuItems.map(item => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={isMobile ? closeSidebar : undefined}
                style={({ isActive }) => ({
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.6rem',
                  padding: '0.65rem 0.75rem',
                  borderRadius: 'var(--sp-radius-sm)',
                  color: '#fff',
                  textDecoration: 'none',
                  fontWeight: 700,
                  fontSize: '0.92rem',
                  background: isActive ? 'rgba(255,255,255,0.18)' : 'transparent',
                  transition: 'background 0.2s',
                })}
              >
                <item.icon size={18} />
                {item.label}
              </NavLink>
            ))}
          </nav>

          <button
            onClick={logout}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.6rem',
              padding: '0.65rem 0.75rem',
              borderRadius: 'var(--sp-radius-sm)',
              background: 'rgba(255,255,255,0.1)',
              border: 'none',
              color: '#fff',
              fontWeight: 700,
              cursor: 'pointer',
              marginTop: 'auto',
            }}
          >
            <LogOut size={18} />
            Cerrar sesión
          </button>
        </aside>

        {/* Contenido principal */}
        <main
          style={{
            flex: 1,
            padding: isMobile ? '4.5rem 1rem 1rem' : '1.5rem', // Ajuste para que no haya espacio extra
            background: 'var(--sp-bg)',
            width: isMobile ? '100%' : `calc(100% - 260px)`,
            minHeight: '100vh',
            boxSizing: 'border-box',
          }}
        >
          {children}
        </main>
      </div>
    </>
  );
};

export default AdminLayout;